<template>
  <card
    style="height: 100%;"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.3)"
  >
    <div v-if="teles.length === 1" class="subtitle">
      {{ teles[0].name }}
    </div>

    <warning
      :height="Math.floor((height / 3) * 2)"
      :loading="loading"
      :data="warning"
    ></warning>

    <div class="card-item">
      <echart
        chart-id="tele"
        :options="options"
        :height="Math.floor(height / 3)"
        :not-merge="true"
      ></echart>
    </div>
  </card>
</template>

<script>
import mixin from '../mixin'
import Card from '../card'
import Warning from './warning'
import Echart from '@/components/Chart'
import { getWarnings } from '@/service/telemetry'
import sleep from '@/utlis/sleep'
import { colors } from '@/utlis/meteorology'

export default {
  mixins: [mixin],
  components: { Card, Warning, Echart },
  props: { devKey: String },
  data() {
    return {
      loading: false,
      pointer: null,
      warnings: [],
      trends: [],
      deviceData: [],
      timer: null
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  computed: {
    warning() {
      return this.warnings.filter(o => o.deviceId === this.deviceId)
    },
    deviceId() {
      if (this.devKey) {
        const dev = this.teles.find(t => t.key === this.devKey)
        return dev.id
      } else {
        return ''
      }
    },
    options() {
      // let row = this.trends[0] ? this.trends[0].data : []
      // let head = ['category'].concat(row.map(r => r.date))
      let source = this.warning.map(t => ({
        name: t.category,
        value: t.summary,
        itemStyle: { color: t.color }
      }))

      return {
        colors: colors,
        legend: {
          show: false,
          left: 4,
          right: '6%',
          bottom: 4,
          type: 'scroll',
          pageButtonPosition: 'end',
          pageIconSize: 8,
          textStyle: { color: '#9aa8d4' },
          pageTextStyle: { color: '#dcdfe6', fontSize: 10 }
        },
        tooltip: {
          trigger: 'axis',
          confine: false,
          appendToBody: false
        },
        xAxis: { type: 'category', show: false },
        yAxis: { show: false },
        grid: { top: '52%', bottom: 34, right: 20 },
        series: [
          {
            type: 'pie',
            radius: ['50%', '90%'],
            center: ['50%', '50%'],
            stillShowZeroSum: true,
            labelLine: { show: false },
            data: source
          }
        ]
      }
    }
  },
  mounted() {
    this.getData()

    this.timer = setInterval(async () => {
      await this.getData()
      this.pointer = 14
    }, 1000 * 60 * 60 * 6)
  },
  methods: {
    async getData() {
      this.loading = true

      const [{ data }] = await Promise.all([
        getWarnings(this.companyId),
        sleep(1)
      ])

      this.trends = data.trends
      this.warnings = data.warnings.map((w, idx) => {
        let summary = 0
        const t = data.trends.find(t => t.id === w.categoryId)

        if (t) {
          summary = t.data.reduce((total, cur) => {
            const dev = cur.devices.find(dev => dev.id === this.deviceId)
            return dev ? total + dev.qty : total
          }, 0)
        }

        const color = colors[idx]

        return { ...w, summary, color }
      })

      this.loading = false
    },
    updatePieValue(evt) {
      let xAxisInfo = evt.axesInfo[0]
      if (xAxisInfo) {
        this.pointer = Math.round(xAxisInfo.value + 1)
      }
    }
  }
}
</script>

<style lang="css" scoped></style>
